import { RootState } from '..';

export const alertList = (state: RootState) => state.alert.alertList;

export const error = (state: RootState) => state.alert.error;

export const action = (state: RootState) => state.alert.action;

export const status = (state: RootState) => state.alert.status;
